export default __webpack_public_path__ + "static/media/IMG-20240708-WA0009.2f5716dd.jpg";